import { Dictionary, TagDefinition } from '../../models';
import { MapGroupViewModel } from './MapGroupViewModel';
import { MarkerDefinition } from './MarkerDefinition';
import { getGroupsMarkers } from './getGroupsMarkers';
import { getTagMarker } from './getTagMarker';
import { MapWidget } from './map.widget';

export const getMarkers = (tags: Dictionary<TagDefinition>, item: MapWidget, groupDictionary: Dictionary<MapGroupViewModel>) => {
    let markers: { [key: string]: MarkerDefinition } = {};
    if (tags && item?.configuration.showTags) {
        const tagMarkers = {};
        Object.values(tags)
            .filter((d) => !!d.customProperties && d.customProperties['latitude'] && d.customProperties['longitude'])
            .forEach((tag, i) => {
                tagMarkers[`m${i}`] = getTagMarker(tag);
            });
        markers = { ...markers, ...tagMarkers };
    }
    if (groupDictionary && item?.configuration.showGroups) {
        const groupMarkers = getGroupsMarkers(groupDictionary);
        markers = { ...markers, ...groupMarkers };
    }
    return markers;
};
